import React from 'react'
import CloseButton from 'react-bootstrap/CloseButton'
import CustomPallete from './customPallete'

interface IProps {
  //   intent: any
  config: any
  closeModal: () => void
  //   inputJson: any[]
  setConfig: React.Dispatch<React.SetStateAction<any[]>>
  data: any
}

const CustomisationConfigModal: React.FC<IProps> = ({ config, closeModal, setConfig, data }) => {
  return (
    <div className='card scroll-y pb-10 w-500px h-490px'>
      <div className='d-flex justify-content-between mx-0 px-0 mb-2'>
        <span className='mb-2 me-auto'></span>
        <CloseButton onClick={closeModal} />
      </div>

      {!!config && (
        <CustomPallete config={config} setConfig={setConfig} data={data} closeModal={closeModal} />
      )}
    </div>
  )
}

export default CustomisationConfigModal
